import React, { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import WeekendDetails from './WeekendDetails';
import ImportantInfo from './ImportantInfo';
import Accommodation from './Accommodation';
import PhotoGallery from './PhotoGallery';
import UploadPhotos from './UploadPhotos';
import DownloadSection from './DownloadSection';
import QRCodeDownload from './QRCodeDownload';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export default function HomePage() {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPhotos = async () => {
    try {
      const response = await axios.get(`${API_BASE}/api/photos`);
      setPhotos(response.data);
    } catch (error) {
      console.error('Error fetching photos:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPhotos();
  }, []);

  const handleUploadSuccess = () => {
    fetchPhotos();
  };

  const handlePhotoDeleted = (photoId) => {
    setPhotos((prev) => prev.filter((p) => p.id !== photoId));
  };

  return (
    <main>
      <HeroSection />
      <WeekendDetails />
      <ImportantInfo />
      <Accommodation />
      <PhotoGallery photos={photos} loading={loading} onPhotoDeleted={handlePhotoDeleted} />
      <UploadPhotos onUploadSuccess={handleUploadSuccess} />
      <DownloadSection />
      <QRCodeDownload />
    </main>
  );
}
